import { type SxProps, type Theme } from '@mui/material'
import { cardChrome } from './cardChrome'

export const styles = {
  card: (grow: boolean) => ({
    ...cardChrome,
    ...(grow ? { flex: 1 } : { flexShrink: 0 }),
    minWidth: '180px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    gap: '16px'
  } satisfies SxProps<Theme>),
  subtitle: {
    color: 'var(--grey-900)'
  } satisfies SxProps<Theme>,
  panel: (color: string, panel: string) => ({
    display: 'flex',
    alignItems: 'stretch',
    boxSizing: 'border-box',
    borderRadius: '12px',
    overflow: 'hidden',
    height: '135px',
    backgroundColor: panel,
    border: '5px solid',
    borderColor: color,
    borderRightWidth: '40px'
  } satisfies SxProps<Theme>),
  iconWell: (color: string) => ({
    backgroundColor: color,
    color: 'var(--white)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    px: '20px',
    flexShrink: 0
  } satisfies SxProps<Theme>),
  valueWell: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    px: '24px'
  } satisfies SxProps<Theme>,
  value: (color: string) => ({
    color,
    fontSize: '50px',
    fontWeight: 600,
    lineHeight: 1,
    fontVariantNumeric: 'lining-nums'
  } satisfies SxProps<Theme>)
}
